<template>
<div class="mcontainer">
  <van-nav-bar fixed title="在线咨询" left-text="返回" left-arrow @click-left="back" />
  <div class="main__body">
    <div class="input__wrapper">
      <van-cell-group title="咨询表单">
        <van-field v-model="input.name"  label="姓名：" placeholder="请填写姓名" />
        <van-field v-model="input.contact" type="number" label="联系方式：" placeholder="请填写联系方式" />
        <van-field v-model="input.title"  label="标题：" placeholder="请填写标题" />
        <van-field v-model="input.ask"  label="咨询内容：" placeholder="请填写咨询内容" type="textarea" autosize rows="1"/>
      </van-cell-group>
      <van-cell-group title="验证">
        <div class="vercode__wrapper clearfix">
          <div class="vercode__input">
            <van-field v-model="verCode" placeholder="请输入验证码" label="验证码" class="vercode" maxlength="4" />
          </div>
          <div class="vercode__img" @click="changeCode">
            <img :src="verCodeUrl">
          </div>
        </div>
      </van-cell-group>
      <div class="btn__wrapper">
        <van-button type="info" size="large" @click="sub">提交</van-button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import {
  mapActions
} from 'vuex'
export default {
  components: {},
  data() {
    return {
      input: {},
      loading: true,
      detail:null,
      verCode:'',
      verCodeUrl:''
    }
  },
  props: [],
  computed: {
    from(){
      return this.$route.query.from
    }
  },
  watch: {},
  created() {
    this.verCodeUrl=window.g.vercodeUrl
  },
  mounted() {},
  destroyed() {},
  methods: {
    back(){
      if(typeof this.from!='undefined'){
        this.$utils.jump('/askNoAuth')
      }else{
        this.$utils.jump('/askListM')
      }
    },
    changeCode(){
      this.verCodeUrl=window.g.vercodeUrl+'?'+Math.random()
    },
    checkInput(input,checkList){
      let err=0
      for (let i = 0; i < checkList.length; i++) {
        let checkItem=$.trim(input[checkList[i]])
        if(checkItem=='' || typeof checkItem=='undefined'){
          err=1
          break
        }
      }
      if(err==0){
        return true
      }else{
        return false
      }
    },
    async sub() {
      let self = this
      let {
        input,
        verCode
      } = self
      let check=this.checkInput(input,['name','contact','title','ask'])
      if(!check){
        this.$utils.toast('请填写完整','err')
        return false
      }
      if($.trim(verCode)==''){
        this.$utils.toast('请填写验证码', 'err')
        return false
      }
      input.verCode=verCode
      let posData = {
        data:input
      }
      let userInfo = this.$utils.getStorage('userInfo')
      if (userInfo != null) {
        posData.auth = true
      }
      let res = await this._subAsk(posData)
      if (res && res.code == 200) {
        if (typeof res.data != 'undefined') {
          this.$dialog({
            title: '提交成功',
            message: '请使用查询代码查询本次提交结果：' + res.data
          }).then(() => {
            self.$utils.jump('/askNoAuth')
          })
          return false
        }
        this.$utils.toast('提交成功')
        setTimeout(()=>{
          self.$utils.back()
        }, 2000)
      }else{
        this.verCodeUrl=window.g.vercodeUrl+'?'+Math.random()
      }
    },
    ...mapActions('api', ['_subAsk'])
  }
}
</script>
<style lang="less" scoped>
.mcontainer {
    .main__body {
        margin-top: 46px;
    }
}
</style>
